import React, { useState, useEffect } from "react";

// Comprehensive country dial codes (sorted by code length desc for correct parsing)
const COUNTRY_CODES = [
  { code: "+1", country: "US", name: "United States" },
  { code: "+91", country: "IN", name: "India" },
  { code: "+44", country: "GB", name: "United Kingdom" },
  { code: "+86", country: "CN", name: "China" },
  { code: "+81", country: "JP", name: "Japan" },
  { code: "+49", country: "DE", name: "Germany" },
  { code: "+33", country: "FR", name: "France" },
  { code: "+39", country: "IT", name: "Italy" },
  { code: "+34", country: "ES", name: "Spain" },
  { code: "+7", country: "RU", name: "Russia" },
  { code: "+82", country: "KR", name: "South Korea" },
  { code: "+61", country: "AU", name: "Australia" },
  { code: "+55", country: "BR", name: "Brazil" },
  { code: "+52", country: "MX", name: "Mexico" },
  { code: "+31", country: "NL", name: "Netherlands" },
  { code: "+32", country: "BE", name: "Belgium" },
  { code: "+41", country: "CH", name: "Switzerland" },
  { code: "+43", country: "AT", name: "Austria" },
  { code: "+46", country: "SE", name: "Sweden" },
  { code: "+47", country: "NO", name: "Norway" },
  { code: "+48", country: "PL", name: "Poland" },
  { code: "+45", country: "DK", name: "Denmark" },
  { code: "+358", country: "FI", name: "Finland" },
  { code: "+353", country: "IE", name: "Ireland" },
  { code: "+351", country: "PT", name: "Portugal" },
  { code: "+30", country: "GR", name: "Greece" },
  { code: "+36", country: "HU", name: "Hungary" },
  { code: "+40", country: "RO", name: "Romania" },
  { code: "+420", country: "CZ", name: "Czech Republic" },
  { code: "+421", country: "SK", name: "Slovakia" },
  { code: "+380", country: "UA", name: "Ukraine" },
  { code: "+381", country: "RS", name: "Serbia" },
  { code: "+385", country: "HR", name: "Croatia" },
  { code: "+386", country: "SI", name: "Slovenia" },
  { code: "+387", country: "BA", name: "Bosnia" },
  { code: "+389", country: "MK", name: "North Macedonia" },
  { code: "+370", country: "LT", name: "Lithuania" },
  { code: "+371", country: "LV", name: "Latvia" },
  { code: "+372", country: "EE", name: "Estonia" },
  { code: "+373", country: "MD", name: "Moldova" },
  { code: "+374", country: "AM", name: "Armenia" },
  { code: "+375", country: "BY", name: "Belarus" },
  { code: "+376", country: "AD", name: "Andorra" },
  { code: "+377", country: "MC", name: "Monaco" },
  { code: "+378", country: "SM", name: "San Marino" },
  { code: "+20", country: "EG", name: "Egypt" },
  { code: "+27", country: "ZA", name: "South Africa" },
  { code: "+212", country: "MA", name: "Morocco" },
  { code: "+213", country: "DZ", name: "Algeria" },
  { code: "+216", country: "TN", name: "Tunisia" },
  { code: "+218", country: "LY", name: "Libya" },
  { code: "+220", country: "GM", name: "Gambia" },
  { code: "+221", country: "SN", name: "Senegal" },
  { code: "+222", country: "MR", name: "Mauritania" },
  { code: "+223", country: "ML", name: "Mali" },
  { code: "+224", country: "GN", name: "Guinea" },
  { code: "+225", country: "CI", name: "Ivory Coast" },
  { code: "+226", country: "BF", name: "Burkina Faso" },
  { code: "+227", country: "NE", name: "Niger" },
  { code: "+228", country: "TG", name: "Togo" },
  { code: "+229", country: "BJ", name: "Benin" },
  { code: "+230", country: "MU", name: "Mauritius" },
  { code: "+231", country: "LR", name: "Liberia" },
  { code: "+232", country: "SL", name: "Sierra Leone" },
  { code: "+233", country: "GH", name: "Ghana" },
  { code: "+234", country: "NG", name: "Nigeria" },
  { code: "+235", country: "TD", name: "Chad" },
  { code: "+236", country: "CF", name: "Central African Republic" },
  { code: "+237", country: "CM", name: "Cameroon" },
  { code: "+238", country: "CV", name: "Cape Verde" },
  { code: "+239", country: "ST", name: "São Tomé" },
  { code: "+240", country: "GQ", name: "Equatorial Guinea" },
  { code: "+241", country: "GA", name: "Gabon" },
  { code: "+242", country: "CG", name: "Congo" },
  { code: "+243", country: "CD", name: "DR Congo" },
  { code: "+244", country: "AO", name: "Angola" },
  { code: "+245", country: "GW", name: "Guinea-Bissau" },
  { code: "+248", country: "SC", name: "Seychelles" },
  { code: "+249", country: "SD", name: "Sudan" },
  { code: "+250", country: "RW", name: "Rwanda" },
  { code: "+251", country: "ET", name: "Ethiopia" },
  { code: "+252", country: "SO", name: "Somalia" },
  { code: "+253", country: "DJ", name: "Djibouti" },
  { code: "+254", country: "KE", name: "Kenya" },
  { code: "+255", country: "TZ", name: "Tanzania" },
  { code: "+256", country: "UG", name: "Uganda" },
  { code: "+257", country: "BI", name: "Burundi" },
  { code: "+258", country: "MZ", name: "Mozambique" },
  { code: "+260", country: "ZM", name: "Zambia" },
  { code: "+261", country: "MG", name: "Madagascar" },
  { code: "+262", country: "RE", name: "Réunion" },
  { code: "+263", country: "ZW", name: "Zimbabwe" },
  { code: "+264", country: "NA", name: "Namibia" },
  { code: "+265", country: "MW", name: "Malawi" },
  { code: "+266", country: "LS", name: "Lesotho" },
  { code: "+267", country: "BW", name: "Botswana" },
  { code: "+268", country: "SZ", name: "Eswatini" },
  { code: "+269", country: "KM", name: "Comoros" },
  { code: "+290", country: "SH", name: "Saint Helena" },
  { code: "+291", country: "ER", name: "Eritrea" },
  { code: "+297", country: "AW", name: "Aruba" },
  { code: "+298", country: "FO", name: "Faroe Islands" },
  { code: "+299", country: "GL", name: "Greenland" },
  { code: "+350", country: "GI", name: "Gibraltar" },
  { code: "+379", country: "VA", name: "Vatican" },
  { code: "+382", country: "ME", name: "Montenegro" },
  { code: "+383", country: "XK", name: "Kosovo" },
  { code: "+423", country: "LI", name: "Liechtenstein" },
  { code: "+500", country: "FK", name: "Falkland Islands" },
  { code: "+501", country: "BZ", name: "Belize" },
  { code: "+502", country: "GT", name: "Guatemala" },
  { code: "+503", country: "SV", name: "El Salvador" },
  { code: "+504", country: "HN", name: "Honduras" },
  { code: "+505", country: "NI", name: "Nicaragua" },
  { code: "+506", country: "CR", name: "Costa Rica" },
  { code: "+507", country: "PA", name: "Panama" },
  { code: "+508", country: "PM", name: "Saint Pierre" },
  { code: "+509", country: "HT", name: "Haiti" },
  { code: "+51", country: "PE", name: "Peru" },
  { code: "+53", country: "CU", name: "Cuba" },
  { code: "+54", country: "AR", name: "Argentina" },
  { code: "+56", country: "CL", name: "Chile" },
  { code: "+57", country: "CO", name: "Colombia" },
  { code: "+58", country: "VE", name: "Venezuela" },
  { code: "+590", country: "GP", name: "Guadeloupe" },
  { code: "+591", country: "BO", name: "Bolivia" },
  { code: "+592", country: "GY", name: "Guyana" },
  { code: "+593", country: "EC", name: "Ecuador" },
  { code: "+594", country: "GF", name: "French Guiana" },
  { code: "+595", country: "PY", name: "Paraguay" },
  { code: "+596", country: "MQ", name: "Martinique" },
  { code: "+597", country: "SR", name: "Suriname" },
  { code: "+598", country: "UY", name: "Uruguay" },
  { code: "+599", country: "CW", name: "Curaçao" },
  { code: "+60", country: "MY", name: "Malaysia" },
  { code: "+62", country: "ID", name: "Indonesia" },
  { code: "+63", country: "PH", name: "Philippines" },
  { code: "+64", country: "NZ", name: "New Zealand" },
  { code: "+65", country: "SG", name: "Singapore" },
  { code: "+66", country: "TH", name: "Thailand" },
  { code: "+670", country: "TL", name: "Timor-Leste" },
  { code: "+672", country: "NF", name: "Norfolk Island" },
  { code: "+673", country: "BN", name: "Brunei" },
  { code: "+674", country: "NR", name: "Nauru" },
  { code: "+675", country: "PG", name: "Papua New Guinea" },
  { code: "+676", country: "TO", name: "Tonga" },
  { code: "+677", country: "SB", name: "Solomon Islands" },
  { code: "+678", country: "VU", name: "Vanuatu" },
  { code: "+679", country: "FJ", name: "Fiji" },
  { code: "+680", country: "PW", name: "Palau" },
  { code: "+681", country: "WF", name: "Wallis and Futuna" },
  { code: "+682", country: "CK", name: "Cook Islands" },
  { code: "+683", country: "NU", name: "Niue" },
  { code: "+685", country: "WS", name: "Samoa" },
  { code: "+686", country: "KI", name: "Kiribati" },
  { code: "+687", country: "NC", name: "New Caledonia" },
  { code: "+688", country: "TV", name: "Tuvalu" },
  { code: "+689", country: "PF", name: "French Polynesia" },
  { code: "+690", country: "TK", name: "Tokelau" },
  { code: "+691", country: "FM", name: "Micronesia" },
  { code: "+692", country: "MH", name: "Marshall Islands" },
  { code: "+850", country: "KP", name: "North Korea" },
  { code: "+852", country: "HK", name: "Hong Kong" },
  { code: "+853", country: "MO", name: "Macau" },
  { code: "+855", country: "KH", name: "Cambodia" },
  { code: "+856", country: "LA", name: "Laos" },
  { code: "+880", country: "BD", name: "Bangladesh" },
  { code: "+886", country: "TW", name: "Taiwan" },
  { code: "+90", country: "TR", name: "Turkey" },
  { code: "+92", country: "PK", name: "Pakistan" },
  { code: "+93", country: "AF", name: "Afghanistan" },
  { code: "+94", country: "LK", name: "Sri Lanka" },
  { code: "+95", country: "MM", name: "Myanmar" },
  { code: "+960", country: "MV", name: "Maldives" },
  { code: "+961", country: "LB", name: "Lebanon" },
  { code: "+962", country: "JO", name: "Jordan" },
  { code: "+963", country: "SY", name: "Syria" },
  { code: "+964", country: "IQ", name: "Iraq" },
  { code: "+965", country: "KW", name: "Kuwait" },
  { code: "+966", country: "SA", name: "Saudi Arabia" },
  { code: "+967", country: "YE", name: "Yemen" },
  { code: "+968", country: "OM", name: "Oman" },
  { code: "+970", country: "PS", name: "Palestine" },
  { code: "+971", country: "AE", name: "UAE" },
  { code: "+972", country: "IL", name: "Israel" },
  { code: "+973", country: "BH", name: "Bahrain" },
  { code: "+974", country: "QA", name: "Qatar" },
  { code: "+975", country: "BT", name: "Bhutan" },
  { code: "+976", country: "MN", name: "Mongolia" },
  { code: "+977", country: "NP", name: "Nepal" },
  { code: "+98", country: "IR", name: "Iran" },
  { code: "+992", country: "TJ", name: "Tajikistan" },
  { code: "+993", country: "TM", name: "Turkmenistan" },
  { code: "+994", country: "AZ", name: "Azerbaijan" },
  { code: "+995", country: "GE", name: "Georgia" },
  { code: "+996", country: "KG", name: "Kyrgyzstan" },
  { code: "+998", country: "UZ", name: "Uzbekistan" },
].filter((c, i, arr) => arr.findIndex((x) => x.code === c.code) === i);

// Sort by code length descending for correct parsing (e.g. +994 before +99)
const SORTED_CODES = [...COUNTRY_CODES].sort(
  (a, b) => b.code.length - a.code.length
);

export const parsePhoneNumber = (phone) => {
  if (!phone) return { countryCode: "+1", number: "" };
  for (const country of SORTED_CODES) {
    if (phone.startsWith(country.code)) {
      return {
        countryCode: country.code,
        number: phone.substring(country.code.length).trim().replace(/\D/g, ""),
      };
    }
  }
  return { countryCode: "+1", number: (phone || "").replace(/\D/g, "") };
};

/** Validates full phone (dial code + number). Min 6 digits, max 15 after dial code. */
export const isValidPhone = (phone) => {
  if (!phone || !phone.trim()) return false;
  const parsed = parsePhoneNumber(phone);
  const len = parsed.number.length;
  return len >= 6 && len <= 15;
};

/**
 * Phone input with dial code selector. Value is full phone (e.g. +919467813457).
 */
const PhoneInput = ({
  value = "",
  onChange,
  required = false,
  error = false,
  placeholder,
  id,
  name,
  onBlur,
  className = "",
}) => {
  const parsed = parsePhoneNumber(value);
  const [countryCode, setCountryCode] = useState(parsed.countryCode);
  const [phoneNumber, setPhoneNumber] = useState(parsed.number);

  useEffect(() => {
    const p = parsePhoneNumber(value);
    setCountryCode(p.countryCode);
    setPhoneNumber(p.number);
  }, [value]);

  const notifyChange = (dial, num) => {
    const full = num ? `${dial}${num}` : "";
    onChange?.(full);
  };

  const inputPlaceholder = placeholder ?? "Phone number";

  const baseInputClasses =
    "bg-white border text-gray-900 placeholder-gray-500 font-medium transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary";
  const errorInputClasses =
    "border-red-500 focus:border-red-500 focus:ring-red-500/20";
  const defaultInputClasses =
    "border-gray-300 hover:border-gray-400";
  const stateClasses = error ? errorInputClasses : defaultInputClasses;

  return (
    <div className={className}>
      <div className="flex items-stretch">
        <div className="relative flex-shrink-0">
          <select
            id={id ? `${id}-dial` : undefined}
            value={countryCode}
            onChange={(e) => {
              const newCode = e.target.value;
              setCountryCode(newCode);
              notifyChange(newCode, phoneNumber);
            }}
            onBlur={onBlur}
            className={`appearance-none block w-[80px] pl-3 pr-8 py-3 border-r-0 rounded-l-xl text-sm ${baseInputClasses} ${stateClasses}`}
          >
            {COUNTRY_CODES.map((c) => (
              <option key={`${c.code}-${c.country}`} value={c.code}>
                {c.code} {c.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <svg
              className="h-5 w-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        <input
          type="tel"
          id={id}
          name={name}
          value={phoneNumber}
          onChange={(e) => {
            const num = e.target.value.replace(/\D/g, "").slice(0, 15);
            setPhoneNumber(num);
            notifyChange(countryCode, num);
          }}
          onBlur={onBlur}
          placeholder={inputPlaceholder}
          maxLength={15}
          className={`flex-1 min-w-0 px-4 py-3 border border-l-0 rounded-r-xl text-sm ${baseInputClasses} ${stateClasses}`}
        />
      </div>
      {typeof error === "string" && (
        <p className="mt-1.5 text-xs font-medium text-red-600 animate-fadeIn">
          {error}
        </p>
      )}
    </div>
  );
};

export default PhoneInput;
